<template>
<v-dialog v-model="show"
	:id="'cancel-order-modal-' + parsedOrder.orderHash"
	max-width="500" persistent :fullscreen="fullscreen"
>
	<v-card>

		<!--Modal Title -->
		<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
			<v-toolbar-title>{{ $t('common.phrase.cancelOrder') }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="show = false">
				<v-icon>mdi-window-close</v-icon>
			</v-btn>
		</v-toolbar>

		<!-- Modal Contents -->
		<v-card-text class="pa-5">

			<div class="mb-2">
				{{ $t('compOrderSummary.cancelOrder.areYouSure') }}
			</div>

			<div class="text-center my-3" v-show="!cancelOrderStatus.txHash">
				<v-btn v-show="!cancelOrderStatus.loading" outlined @click="hideModal()" class="mr-3">
					{{ $t('compOrderSummary.cancelOrder.doNotCancel') }}
				</v-btn>
				<v-btn color="error" @click="cancelOrder()" :disabled="cancelOrderStatus.loading">
					{{ $t('compOrderSummary.cancelOrder.yesCancel') }}
					 <ButtonLoading v-show="cancelOrderStatus.loading" class="ml-3" />
				</v-btn>
			</div>

			<div class="text-center my-2 mx-3" v-if="cancelOrderStatus.txHash && cancelOrderStatus.loading">
				<PendingTransaction :txhash="cancelOrderStatus.txHash" :txurl="networkConfig.txURL"></PendingTransaction>
			</div>

		</v-card-text>

		<v-card-actions v-if="fullscreen">
			<v-spacer></v-spacer>
			<v-btn color="primary" outlined text class="mr-3" @click="show = false">
				<v-icon>mdi-window-close</v-icon> {{ $t('common.verb.close')}}
			</v-btn>
		</v-card-actions>

	</v-card>
</v-dialog>

</template>

<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import Preloader from "@/components/Preloader"
import PendingTransaction from "@/components/PendingTransaction"
import ButtonLoading from "@/components/ButtonLoading"
import { TX_DEFAULTS } from '@/config/constants'
import { getCurrentGasPrice } from '@/utils/utils'

export default {
	name: 'CancelOrderModal',
	props: {
		parsedOrder: { type: Object },
    fullscreen: { type: Boolean, default: false},
  },
	components: {
		Preloader,
		PendingTransaction,
		ButtonLoading
	},
	data () {
		return {
			show: false,
			cancelOrderStatus: {
				loading: false,
				txHash: null
			},
		}
	},
	computed: {
		...mapGetters({
			network: 'getNetwork',
			account: 'getAccount',
			tokenInfo: 'getTokenInfo',
			myAddress: 'getUserAccount',
			networkConfig: 'getNetworkConfig',
			web3Wrapper: 'getWeb3Wrapper',
			providerEngine: 'getProviderEngine',
			contractWrappers: 'getContractWrappers',
			contractAddresses: 'getContractAddresses',
		}),
	},
	methods: {
		...mapActions(['loadNetwork', 'loadTokenInfo', 'loadAccount']),

		/* ------------------------------------------------------ */
		// async init () {
		//   // console.log('UnwrapETH init')
		//   this.initializationDone = false
		//   if (this.networkNeedReload) {
		//     await this.loadNetwork()
		//   }
		//   if (this.tokenInfoNeedReload) {
		//     await this.loadTokenInfo()
		//   }
		//   if (this.accountNeedReload) {
		//     await this.loadAccount()
		//   }
		//   this.initializationDone = true
		// },
		showModal () {
			this.show = true
		},
		hideModal () {
			this.show = false
		},
		async cancelOrder(deleteRecord = false) {

			this.emitLoading()

			this.cancelOrderStatus = {
				loading: true,
				txHash: null
			}

			// Canceling order transaction
			const signedOrder = this.parsedOrder.signedOrder
			// console.log(signedOrder)
			try {
				const gasPrice = await getCurrentGasPrice(this.network.id)
				this.cancelOrderStatus.txHash = await this.contractWrappers.exchange
					.cancelOrder(signedOrder)
					.sendTransactionAsync({
						from: this.myAddress,
						// gas: TX_DEFAULTS.gas,
            gasPrice: gasPrice,
				})
				if (this.cancelOrderStatus.txHash) {
					await this.web3Wrapper.awaitTransactionMinedAsync(this.cancelOrderStatus.txHash)
					this.emitComplete(this.parsedOrder.orderHash)
				}
			} catch (err) {
				console.log(err)
				this.emitFailure(this.parsedOrder.orderHash)
			} finally {
				this.cancelOrderStatus.loading = false
				this.hideModal()
			}


		},
		emitLoading (orderHash) {
			this.$emit('cancel-order-loading', orderHash)
		},
		emitFailure (orderHash) {
			this.$emit('cancel-order-failure', orderHash)
		},
		emitComplete (orderHash) {
			this.$emit('cancel-order-complete', orderHash)
		}
	},
	created () {
	},
	beforeDestroy () {
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
